
import { getOptionItemList } from '@/api/optionItem';
import { getReservationCategoryList } from '@/api/reservationCategory';
import { addFavoriteItem, deleteFavoriteItem } from '@/api/favoriteItem';
import { getStoreInfoList } from '@/api/storeInfo';
import {
  getLat,
  getLng,
  setLat,
  setLng,
} from '@/utils/cookies';
import { getCurrentPosition } from '@/utils/mylocation';
import moment from 'moment';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/user';
import InfiniteLoading from 'vue-infinite-loading';
import { LatLng } from '../latlng';

@Component({
  components: {
    InfiniteLoading,
  },
})

export default class extends Vue {
  @Watch('filterOptionVisible')
  private handleChangeFilterOptionVisible() {
    if (!this.filterOptionVisible) {
      (this.$refs.priceSlider as any).$refs.button1.handleMouseLeave();
      (this.$refs.priceSlider as any).$refs.button2.handleMouseLeave();
    }
  }

  @Watch('searchPrice', { deep: true })
  private handleChangeSearchPrice() {
    if (this.searchPrice && this.searchPrice.length === 2) {
      this.listQuery.startPrice = this.searchPrice[0];
      this.listQuery.endPrice = this.searchPrice[1];
    }
  }

  mounted() {
    this.getCategoryList();
    this.getRegionList();
    this.setUserLocation();
  }

  private filterOptionVisible = false;

  private listQuery: any = {
    searchValue: this.$route.query.searchValue,
    page: 1,
    size: 20,
    startDate: this.$route.query.startDate ? this.$route.query.startDate : moment().format('YYYY-MM-DD'),
    lat: 0,
    lng: 0,
    sort: 'recommand',
    region: this.$route.query.region ? this.$route.query.region : '',
    startPrice: 0,
    endPrice: 500000,
    categories: '',
    options: '',
    adult: this.$route.query.adult ? this.$route.query.adult : 2,
    child: this.$route.query.child ? this.$route.query.child : 0,
    industryIdx: 6,
    filterCnt: 0,
  };

  private formQuery: any = {
    startDate: this.$route.query.startDate ? this.$route.query.startDate : moment().format('YYYY-MM-DD'),
    people: 1,
  }

  private apiUrl = process.env.VUE_APP_COMMON_API;

  private filterSortDrawer = false;

  private storeList: any = [];

  private totalElements: Number = 0;

  private categoryList: any = [];

  private loading = false;

  private searchCategories = [];

  private searchOptions = [];

  private searchDate = moment().format('YYYY-MM-DD');

  private searchPrice = [0, 1000000000];

  private datePickerVisible = false;

  private regionList = [];

  private isNoMore = false;

  private sortList = [
    { label: '추천순', value: 'recommand' },
    { label: '거리순', value: 'distance' },
  ]

  private placeSearch = '';

  private handleClickSort(sort: string) {
    this.loading = true;
    this.storeList = [];
    this.filterSortDrawer = false;
    this.listQuery.page = 1;
    this.listQuery.sort = sort;
    this.getStoreList();
  }

  private getSortLabel() {
    let label = '';
    const idx = this.sortList.findIndex((sort: any) => sort.value === this.listQuery.sort);
    if (idx > -1) label = this.sortList[idx].label;
    return label;
  }

  private getStoreList() {
    this.loading = true;
    if (this.$route.query.adult && this.$route.query.child) {
      this.listQuery.people = Number(this.$route.query.adult) + Number(this.$route.query.child);
    }
    getStoreInfoList({ ...this.listQuery, useDate: this.listQuery.startDate }).then((res) => {
      this.storeList = this.storeList.concat(res.data.content);
      this.isNoMore = res.data.last;
      this.loading = false;
      this.searchAsync = false;
    });
  }

  hasSortOption(value: string): boolean {
    return this.sortList.some((item) => item.value === value);
  }

  private async setUserLocation() {
    try {
      const position = await getCurrentPosition();
      this.listQuery.lat = position.lat;
      this.listQuery.lng = position.lng;
    } catch (error) {
      this.$message.error('위치 정보를 가져오는 데 실패했습니다.');
    }
    this.getStoreList();
  }

  private getCategoryList() {
    getReservationCategoryList({ typeUid: '14' }).then((res) => {
      this.categoryList = res.data;
    });
  }

  private searchAsync = false;

  private handleSearch() {
    this.loading = true;

    if (this.searchAsync) {
      this.$message.error('검색중 입니다. 잠시만 기다려 주십시오.');
    } else {
      this.searchAsync = true;
      this.storeList = [];
      this.listQuery.page = 1;
      this.listQuery.categories = this.searchCategories.join(',');
      this.listQuery.options = this.searchOptions.join(',');
      this.getStoreList();
    }
  }

  private getRegionList() {
    getOptionItemList('REGION').then((res) => {
      this.regionList = res.data;
    });
  }

  private handleResetFormQuery() {
    this.formQuery = {
      people: this.listQuery.people,
      startDate: this.listQuery.startDate,
    };
    const calendarRef: any = this.$refs.calendar;
    if (calendarRef) calendarRef.removeActiveClass();
  }

  private handleApplyFormQuery() {
    this.listQuery = {
      ...this.listQuery,
      ...this.formQuery,
    };
    this.datePickerVisible = false;
  }

  private handleAddFavoriteItem(idx: any) {
    if (UserModule.token) {
      addFavoriteItem({ storeInfoIdx: idx }).then(() => {
        this.$message.success('저장되었습니다.');
      });
    } else {
      this.$message.info('로그인이 필요한 서비스입니다.');
    }
  }

  private handleApplyFilter() {
    this.filterOptionVisible = false;
    this.handleSearch();
    this.listQuery.filterCnt = this.getFilterList().length; /* 검색영역의 선택한 필터 갯수 */
  }

  private getFilterList() {
    const filterList: any = [];

    this.searchCategories.forEach((category: any) => {
      const index = this.categoryList.findIndex((x: any) => x.uid === category);
      if (index > -1) filterList.push(this.categoryList[index].name);
    });

    return filterList;
  }

  private filterDefault = {
    date: '',
    personnel: '성인2명 / 아동1명',
    personnelAdult: 2,
    personnelChild: 1,
    village: '',
  }

  private filterOptionChange() {
    this.filterOptionVisible = !this.filterOptionVisible;
  }

  private handleMoreStoreList($state: any) {
    this.listQuery.page += 1;
    this.loading = true;
    if (this.$route.query.adult && this.$route.query.child) {
      this.listQuery.people = Number(this.$route.query.adult) + Number(this.$route.query.child);
    }
    getStoreInfoList({ ...this.listQuery, useDate: this.listQuery.startDate }).then((res) => {
      this.loading = false;
      this.storeList = this.storeList.concat(res.data.content);
      if (res.data.content.length > 0) {
        $state.loaded();
      } else {
        this.isNoMore = true;
        $state.complete();
      }
    }).catch((error) => {
      this.$message.error('정보를 불러오는데 실패했습니다.');
      this.loading = false;
      $state.complete();
    });
  }

  private truncateText(text: string, maxLength: number): string {
    if (text.length > maxLength) {
      return `${text.slice(0, maxLength)}...`;
    }
    return text;
  }

  private distanceType(distance: number | string): number {
    const value = Number(distance);
    if (value > 1000) {
      return value / 1000;
    }
    return 0;
  }

  private favoriteFlag = false;

  private async handleAddFavoriteStay(event: Event, idx: any, type: number) {
    if (this.favoriteFlag) {
      this.$message.info('저장중입니다.');
      return;
    }
    this.favoriteFlag = true;
    if (UserModule.token) {
      const target = (event.target as HTMLElement)?.parentElement?.parentElement?.parentElement?.parentElement;
      if (target?.classList.contains('active')) {
        if (target.getAttribute('data-id')) {
          await deleteFavoriteItem(target.getAttribute('data-id')).then(() => {
            this.$message.success('삭제되었습니다.');
            target.classList.remove('active');
            target.removeAttribute('data-id');
          });
        } else {
          this.$message.info('해당 서비스를 찾을 수 없습니다.');
        }
      } else if (target && !(target?.classList.contains('active'))) {
        let query = {};
        if (type === 1) query = { stayIdx: idx };
        else if (type === 2) query = { storeInfoIdx: idx };
        await addFavoriteItem(query).then((res) => {
          this.$message.success('저장되었습니다.');
          target.classList.add('active');
          target.setAttribute('data-id', res.data);
        });
      }
    } else {
      this.$message.info('로그인이 필요한 서비스입니다.');
    }
    this.favoriteFlag = false;
  }

  private hotplaceNavigateToDetail(storeIdx: string) {
    const params = { idx: storeIdx };
    const query = { ...this.$route.query, ...this.listQuery };
    this.$router.push({ name: 'PlaceView', params, query });
  }
}
